import { render } from "./PurchaseItemReport.vue?vue&type=template&id=164b0d7c"
import script from "./PurchaseItemReport.vue?vue&type=script&lang=js"
export * from "./PurchaseItemReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__